import WearLikeThisImageService from '@/services/api/WearLikeThisImageService';

const state = {
  wearLikeThisImages: [],
  wearLikeThisImagesErrors: null
};

const getters = {
  wearLikeThisImages: state => state.wearLikeThisImages,
  wearLikeThisImagesErrors: state => state.wearLikeThisImagesErrors
};

const actions = {
  fetchWearLikeThisImages({ commit }, payload) {
    const params = {
      userId: payload.userId,
      capsuleId: payload.capsuleId,
    }

    return WearLikeThisImageService.getAll(params)
      .then((response) => {
        commit('SAVE_WEAR_LIKE_THIS_IMAGES', response.data);
      })
      .catch(error => {
        commit('SAVE_WEAR_LIKE_THIS_IMAGES_ERROR', error.message);
      })
  },

  createWearLikeThisImage({ commit }, formData) {
    return WearLikeThisImageService.create(formData)
      .then((response) => {
        commit('APPEND_WEAR_LIKE_THIS_IMAGE', response.data);

        // INFO: Returned data needed by Uppload library
        return response.data
      })
      .catch(error => {
        commit('SAVE_WEAR_LIKE_THIS_IMAGES_ERROR', error.message);
      })
  },

  destroyWearLikeThisImage({ commit }, { wearLikeThisImage }) {
    return WearLikeThisImageService.destroy(wearLikeThisImage.id)
      .then(() => {
        commit('REMOVE_WEAR_LIKE_THIS_IMAGE', wearLikeThisImage);
        return true;
      })
      .catch(error => {
        commit('SAVE_WEAR_LIKE_THIS_IMAGES_ERROR', error.message);
        return false;
      })
  },

  async resetWearLikeThisImages({ commit }) {
    commit('RESET_WEAR_LIKE_THIS_IMAGES');
  }
};

const mutations = {
  RESET_WEAR_LIKE_THIS_IMAGES(state) {
    state.wearLikeThisImages = [];
  },

  REMOVE_WEAR_LIKE_THIS_IMAGE(state, wearLikeThisImage) {
    const index = state.wearLikeThisImages.findIndex((obj) => obj.id === wearLikeThisImage.id)

    if (index > -1) state.wearLikeThisImages.splice(index, 1);
  },

  APPEND_WEAR_LIKE_THIS_IMAGE(state, response) {
    state.wearLikeThisImages.push(response);
  },

  SAVE_WEAR_LIKE_THIS_IMAGES(state, records) {
    state.wearLikeThisImages = records.length > 0 ? records : []
  },

  SAVE_WEAR_LIKE_THIS_IMAGES_ERROR(state, errors) {
    state.wearLikeThisImagesErrors = errors
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/wear-like-this-image/index.js